import { render, staticRenderFns } from "./CreateAlfException.vue?vue&type=template&id=5e7d9c05&scoped=true"
import script from "./CreateAlfException.vue?vue&type=script&lang=js"
export * from "./CreateAlfException.vue?vue&type=script&lang=js"
import style0 from "./CreateAlfException.vue?vue&type=style&index=0&id=5e7d9c05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d9c05",
  null
  
)

export default component.exports